import { Injectable } from '@angular/core';
import { ApiService } from './api';
import { Comment, CommentPayload } from '../upas/comments/comment.interface';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CommentsService {
  path: string = '/api/v2/upas';

  constructor(private apiService: ApiService) { }

  getComments(upaId: number): Observable<Comment[]> {
    return this.apiService.get(`${this.path}/${upaId}/comments`)
  }

  createComment(upaId: number, comment: CommentPayload): Observable<Comment> {
    return this.apiService.post(`${this.path}/${upaId}/comments`, { ...comment });
  }

  toggleIsResolved(upaId: number, commentId: number): Observable<Comment> {
    return this.apiService.post(`${this.path}/${upaId}/comments/${commentId}/toggle_resolution`, {});
  }
}

